import type { TOC } from '@ember/component/template-only';

interface ParityParityManagerDrawerSectionSignature {
  Args: {
    disableBorder?: boolean;
    subtitle?: string;
    title: string;
  };
  Blocks: {
    default: [];
  };
}

const ParityParityManagerDrawerSection = <template>
  <div
    class="drawer-section
      {{unless @disableBorder 'drawer-section--has-border-bottom'}}"
  >
    <h3 class="drawer-section__title">{{@title}}</h3>
    {{#if @subtitle}}
      <p class="drawer-section__subtitle text-300--regular">{{@subtitle}}</p>
    {{/if}}

    {{yield}}
  </div>
</template> satisfies TOC<ParityParityManagerDrawerSectionSignature>;

export default ParityParityManagerDrawerSection;
